/* ==========================================================================
   Zondela Stats Counter — animación de conteo con IntersectionObserver
   - Se activa solo cuando la sección es visible
   - Se ejecuta una sola vez por métrica
   - Formato de miles automático (8000 -> 8,000)
   - Respeta prefers-reduced-motion
   - Sin librerías externas
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-zsc-counters]';
  var prefersReduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // easeOutExpo para un movimiento fluido y elegante
  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function formatNumber(value, decimals, useGrouping, locale) {
    try {
      return new Intl.NumberFormat(locale || 'en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: useGrouping
      }).format(value);
    } catch (e) {
      var fixed = value.toFixed(decimals);
      if (!useGrouping) return fixed;
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
  }

  function animateValue(el) {
    if (el.dataset.zscDone === 'true') return;
    el.dataset.zscDone = 'true';

    var target = parseFloat(el.dataset.zscTarget);
    if (isNaN(target)) return;

    var decimals = parseInt(el.dataset.zscDecimals, 10) || 0;
    var duration = parseInt(el.dataset.zscDuration, 10) || 2000;
    var useGrouping = el.dataset.zscGrouping !== 'false';
    var locale = el.dataset.zscLocale || 'en-US';

    // Si el conteo está desactivado o se prefiere menos movimiento: valor final directo
    if (prefersReduced || el.dataset.zscAnimate === 'false' || duration <= 0) {
      el.textContent = formatNumber(target, decimals, useGrouping, locale);
      return;
    }

    var startTime = null;

    function step(now) {
      if (startTime === null) startTime = now;
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var current = target * easeOutExpo(progress);
      el.textContent = formatNumber(current, decimals, useGrouping, locale);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = formatNumber(target, decimals, useGrouping, locale);
      }
    }

    window.requestAnimationFrame(step);
  }

  function runSection(section) {
    var values = section.querySelectorAll('[data-zsc-target]');
    for (var i = 0; i < values.length; i++) {
      animateValue(values[i]);
    }
  }

  function init() {
    var sections = document.querySelectorAll(SELECTOR);
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < sections.length; i++) runSection(sections[i]);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runSection(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25, rootMargin: '0px 0px -10% 0px' }
    );

    for (var j = 0; j < sections.length; j++) {
      observer.observe(sections[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SELECTOR);
    if (!section) return;
    var values = section.querySelectorAll('[data-zsc-target]');
    for (var i = 0; i < values.length; i++) {
      values[i].dataset.zscDone = 'false';
    }
    runSection(section);
  });
})();
